import { Box, Button, Grid, Modal, Stack, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import PickUpCartComponent from '../../../components/PickUpCartComponent';
import Images from '../../../utils/Images';
import { useTheme } from '@emotion/react';
import { AddCircleOutline, AddCircleRounded, DeleteOutlineOutlined, RemoveCircleOutlined } from '@mui/icons-material';
import { color } from 'framer-motion';
import PickUpTime from '../../../components/PickUpTime';
import { Player } from '@lottiefiles/react-lottie-player';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../../../utils/Api';
import toast from 'react-hot-toast';

const SubscriptionCart = () => {
    const token = localStorage.getItem("token");
    const [outletData, setOutletData] = useState(JSON.parse(localStorage.getItem('selectedStoreData')));
    const theme = useTheme();
    const matchesMdUp = useMediaQuery(theme.breakpoints.up('md'));
    const [settingTimes, setSettingTimes] = useState(false);
    const getCartKey = (subId) => `localCart_${subId}`;
    const [localCart, setLocalCart] = useState(() => {
        const saved = localStorage.getItem('localCart');
        return saved ? JSON.parse(saved) : [];
    });
    const [orderItems, setOrderItems] = useState(2);
    const location = useLocation();
    const navigate = useNavigate();
    const { sub } = location.state || {};
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [limitExceeded, setLimitExceeded] = useState(false);
    const handleCloseModal = () => setLimitExceeded(false);
    const [tab, setTab] = useState('DINE-IN');
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('userDataLogin')));
    const orderType = localStorage.getItem("selectedOrderType");

    const generateTimeSlots = (startTime, intervalMins = 5, count = 4) => {
        const slots = [];
        const date = new Date(startTime);

        for (let i = 0; i < count; i++) {
            const formatted = date.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
            slots.push({ formatted, increment: intervalMins });
            date.setMinutes(date.getMinutes() + intervalMins);
        }

        return slots;
    };

    const totalMakingTime = localCart.reduce((acc, item) => {
        const time = parseInt(item?.makingTime || '0', 10);
        return acc + (isNaN(time) ? 0 : time);
        console.log('time', time);
    }, 0);

    const readyTimeOffsetMins = totalMakingTime + 5;
    const readyTimeDate = new Date(Date.now() + readyTimeOffsetMins * 60000);
    const readyTimeFormatted = readyTimeDate.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });

    const availableSlots = useMemo(() => generateTimeSlots(readyTimeDate, 5, 4), [readyTimeDate]);

    useEffect(() => {
        const first = availableSlots[0];
        if (!first) return;

        if (!selectedSlot || !availableSlots.some(s => s.formatted === selectedSlot)) {
            setSelectedSlot(first.formatted);
        }
    }, [availableSlots, selectedSlot]);

    useEffect(() => {
        const stored = localStorage.getItem(getCartKey(sub?._id));
        setLocalCart(stored ? JSON.parse(stored) : []);
    }, [sub]);

    const updateCartInStorage = (updatedCart) => {
        localStorage.setItem(getCartKey(sub?._id), JSON.stringify(updatedCart));
        setLocalCart(updatedCart);
    };

    const subscriptionLimit = () => {
        if (localCart.reduce((sum, item) => sum + (item.quantity || 1), 0) >= sub?.orderQuantity) {
            setLimitExceeded(true);
        } else {
            setLimitExceeded(false);
        }
    };

    const handleIncrement = (index) => {
        const totalQty = localCart.reduce((sum, item, i) =>
            i === index ? sum + item.quantity + 1 : sum + item.quantity, 0
        );
        if (totalQty > sub?.orderQuantity) {
            setLimitExceeded(true);
            return;
        }
        const updatedCart = [...localCart];
        updatedCart[index].quantity = (updatedCart[index].quantity || 1) + 1;
        updateCartInStorage(updatedCart);
    };

    const handleDecrement = (index) => {
        const updatedCart = [...localCart];
        const currentQty = updatedCart[index].quantity || 1;
        if (currentQty > 1) {
            updatedCart[index].quantity = currentQty - 1;
            updateCartInStorage(updatedCart);
        } else {
            handleRemove(index);
        }
        const totalQty = localCart.reduce((sum, item, i) =>
            i === index ? sum + item.quantity + 1 : sum + item.quantity, 0
        );
    };

    const handleRemove = (index) => {
        const updatedCart = [...localCart];
        updatedCart.splice(index, 1);
        updateCartInStorage(updatedCart);
        if (updatedCart.length === 0) {
            navigate(-1);
        }
    };

    const convertTimeToMinutes = (timeStr) => {
        if (!timeStr) return 0;
        let time = timeStr;
        let period = '';
        if (timeStr.includes(' ')) {
            [time, period] = timeStr.split(' ');
        }
        let [hours, minutes] = time.split(':').map(Number);
        if (period?.toUpperCase() === 'PM' && hours !== 12) {
            hours += 12;
        } else if (period?.toUpperCase() === 'AM' && hours === 12) {
            hours = 0;
        }
        return (hours * 60) + minutes;
    };

    const createOrder = async () => {
        try {
            // Prepare order items
            const orderItems = localCart.map(item => {
                const orderItem = {
                    product: item?._id,
                    quantity: item?.quantity,
                    "sourceType":"WEBSITE",
                };
                if (item?.selectedAddons && Array.isArray(item?.selectedAddons)) {
                    orderItem.addons = item?.selectedAddons?.map(addon => ({
                        _id: addon?._id,
                        selectedValue: addon?.value || addon?.selectedValue,
                        price: addon?.price,
                        selectedValueId: addon?.selectedValueId,
                    }));
                }
                return orderItem;
            });

            // Order body
            const params = {
                outletId: outletData?._id,
                subscriptionId: sub?._id,
                userId: userData?._id, // or get from context/store
                ordersType: orderType, // "DINE-IN" or "PICK-UP"
                pickupOption: tab, // "DINE-IN" or "PICK-UP"
                "arrivalTimeDurationInMinutes": totalMakingTime,
                "readyTime": selectedSlot,
                source: "WEBSITE",
                totalMakingTime: totalMakingTime, // already in minutes from your calculation
                // pickUpTime: selectedSlot, // send as string, or convert as needed
                orderItems,
            };

            const response = await axios.post(
                `${API.BASE_URL_2}order/createSubscriptionOrder`,
                params,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            // Success actions
            toast.success("Order placed successfully!");
            // Optionally clear cart, navigate, etc.
            localStorage.removeItem(getCartKey(sub?._id));
            navigate('/orderDetails', {
                state: {
                    orderDetails: response?.data?.data?.orders[0],
                    subscription: sub,
                    screenLocation: "PAYMENT",
                    fromSubscriptionCart: true
                }
            });
        } catch (error) {
            console.error("Error creating order:", error.response?.data?.error || error.message);
            toast.error(error.response?.data?.error || "Failed to place order. Please try again.");
        }
    };

    // const handleCreateSubOrder = async (values, { setSubmitting }) => {
    //     // console.log('Submitted values:', values);
    //     setSubmitting(false);
    //     try {
    //         const requestBody = {
    //             "outletId": "681c41aeb1946a34e08f73e7",
    //             "subscriptionId": "685a424b68e3d973e8219451",
    //             "userId": "67efc8c62f3e2842fa28d655",
    //             "ordersType": "DELIVERY",
    //             "totalMakingTime": "34",
    //             "orderItems": [
    //                 {
    //                     "product": "66ea70b149029a74b5e06b3c",
    //                     "quantity": 2,
    //                     "addons": [
    //                         {
    //                             "_id": "66509ae2eb13f5a07374f1a5",
    //                             "selectedValue": "Extra Cheese",
    //                             "price": 10,
    //                             "selectedValueId": "66509ae2eb13f5a07374f1a6"
    //                         }
    //                     ]
    //                 }
    //             ]
    //         };
    //         const response = await axios.post(`${API.BASE_URL_2}delivery-details`, requestBody, {
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //             },
    //         });
    //         console.log('Order Placed', response.data);
    //         toast.success("Order placed Successfully");
    //     } catch (error) {
    //         console.error('Error adding address:', error);
    //         toast.error(error.response.data.error);
    //     }
    // };

    useEffect(() => {
        window.scroll(0, 0);
        const stored = localStorage.getItem(getCartKey(sub?._id));
        setLocalCart(stored ? JSON.parse(stored) : []);
        console.log('cart ', localCart);
    }, []);

    useEffect(() => {
        subscriptionLimit();
        console.log('cart ');
    }, [handleDecrement, handleIncrement, handleRemove]);

    return (
        <Box className="subscriptionCart">
            <PickUpCartComponent />

            <Grid className="productsListing" container spacing={2}>
                {limitExceeded && (
                    <img style={{ position: 'absolute', top: 25, left: '50%', transform: 'translateX(-30%) translateY(-0%)', zIndex: 999 }} src={Images.subLimit} alt="Subscription Limit Reached" />
                )}
                {localCart?.map((product, index) => {
                    const isLastInRow = (index + 1) % 3 === 0;
                    const isLastRow = index >= localCart.length - 3;

                    return (
                        <Grid item sm={12} md={4} key={product?._id || index}>
                            <Box
                                sx={{
                                    ...(matchesMdUp
                                        ? { borderRight: isLastInRow ? 'none' : '1px dashed #D6D6D6' }
                                        : { borderRight: 'none', borderLeft: 'none' }),
                                    borderBottom: isLastRow ? 'none' : '1px dashed #D6D6D6',
                                }}
                                className={`product-item ${product?.isExhausted ? 'exhausted' : ''}`}
                            >
                                <Grid container>
                                    <Grid item xs={4} sm={4} className="imageBox">
                                        <img className="image" src={product?.displayImageUrl} alt="Product" />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                        <Typography className="productName">{product?.name}</Typography>
                                        {product?.selectedAddons && (
                                            <Typography className="productDesc">
                                                {Object.values(product.selectedAddons)
                                                    .flat()
                                                    .filter(addonVal => addonVal?.value)
                                                    .map((addonVal, i, arr) => (
                                                        <span key={i}>
                                                            {addonVal.label}
                                                            {i !== arr.length - 1 && ', '}
                                                        </span>
                                                    ))}
                                            </Typography>
                                        )}
                                        <Stack direction="row" spacing={1} alignItems="center" alignSelf={'baseline'} pt={3} pr={2} flexWrap="nowrap" justifyContent={'space-between'}>
                                            {product?.foodType === 'VEG/VEGAN' ? (
                                                <Stack direction="row" spacing={0.5} alignItems="center" flexShrink={0}>
                                                    <img className="veg-nonveg" src={Images.veg} alt="veg" style={{ height: 24, width: 24 }} />
                                                    <img className="veg-nonveg" src={Images.vegan} alt="vegan" style={{ height: 24, width: 24 }} />
                                                </Stack>
                                            ) : (
                                                <img
                                                    className="veg-nonveg"
                                                    src={
                                                        product?.foodType === 'VEG'
                                                            ? Images.veg
                                                            : product?.foodType === 'VEGAN'
                                                                ? Images.vegan
                                                                : Images.nonVeg
                                                    }
                                                    alt={product?.foodType?.toLowerCase()}
                                                    style={{ height: 24, width: 24 }}
                                                />
                                            )}

                                            <Stack direction="row" spacing={1} alignItems="center" flexWrap="nowrap">
                                                {product?.quantity > 1 ? (
                                                    <RemoveCircleOutlined
                                                        sx={{ color: '#09A5F7', cursor: 'pointer' }}
                                                        onClick={() => handleDecrement(index)}
                                                    />
                                                ) : (
                                                    <DeleteOutlineOutlined
                                                        sx={{ color: '#FF5255', cursor: 'pointer' }}
                                                        onClick={() => handleRemove(index)}
                                                    />
                                                )}
                                                <Typography color="#6B6C6E" noWrap>{product?.quantity || 1}</Typography>
                                                <AddCircleRounded
                                                    sx={{ color: '#09A5F7', cursor: 'pointer' }}
                                                    onClick={() => handleIncrement(index)}
                                                />
                                            </Stack>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>

            <Box className="pickUpTimeComponent">
                <Box className="firstBox">
                    <img src={Images.pickUpIcon} className="pickIcon" alt="pickUpIcon" />
                    <Typography className="pickUpText">Set Up Pick Up Time</Typography>
                </Box>
                {settingTimes ? (
                    <Box className="secondBg" sx={{ textAlign: 'center' }}>
                        {/* <img src={Images.timeLoading} style={{ height: '80px' }} /> */}
                        <Player autoplay loop={true} keepLastFrame={true} src={Images.timeLoading} style={{ height: '100px' }} />
                        <Typography className='availableSlot'>Fetching Available Time Slots</Typography>
                    </Box>
                ) : (
                    <Box className="secondBg">
                        <Box className="secondBox">
                            <Typography className='readyTime'>Ready Time: <span style={{ fontWeight: '600' }}>{selectedSlot}</span> </Typography>
                            <Typography className='availableSlot'>Available Slots:</Typography>
                        </Box>
                        <Box className="timeSlots">
                            <Grid container spacing={2}>
                                {availableSlots?.map((slot, index) => (
                                    <Grid item xs={3} key={index}>
                                        <Typography
                                            className={`time ${selectedSlot === slot.formatted ? 'active' : ''}`}
                                            onClick={() => setSelectedSlot(slot?.formatted)}
                                            sx={{ textAlign: 'center' }}
                                        >
                                            {slot?.formatted}
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box>
                )}

            </Box>

            <Box className="pickOptions">
                <Typography variant='h6' sx={{ p: 0, m: 0, ml: 3, color: '#0E4961' }} className="pickUpText">Pick Up Options</Typography>
                <Grid container className="subTabs" justifyContent="space-around">
                    <Grid
                        item xs={5}
                        className={`tab ${tab === 'DINE-IN' ? 'active' : ''}`}
                        onClick={() => setTab('DINE-IN')}
                    >
                        Dine-In
                    </Grid>
                    <Grid
                        item xs={5}
                        className={`tab ${tab === 'TAKE-AWAY' ? 'active' : ''}`}
                        onClick={() => setTab('TAKE-AWAY')}
                    >
                        Take-away
                    </Grid>
                </Grid>
            </Box>

            <Box className="orderBtn" onClick={createOrder}>
                <Typography variant='body1'>Place Order</Typography>
            </Box>

            {/* <Modal open={limitExceeded} onClose={handleCloseModal}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: '#fff',
                        padding: 4,
                        borderRadius: 2,
                        boxShadow: 24,
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Item Limit Exceeded
                    </Typography>
                    <Typography gutterBottom>
                        You cannot add more than {orderItems} items to the cart.
                    </Typography>
                    <Button onClick={handleCloseModal} variant="contained">
                        OK
                    </Button>
                </Box>
            </Modal> */}

        </Box>
    );
};

export default SubscriptionCart;
